/* ZIPFROST */
(function () {
  if (window.__zf) return;
  window.__zf = true;

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
    try { return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGallery(root) {
    var track = root.querySelector('[data-zf-track]');
    if (!track) return null;
    var slides = $$(track, '[data-zf-slide]');
    var thumbs = $$(root, '[data-zf-thumb]');
    var prev = root.querySelector('[data-zf-prev]');
    var next = root.querySelector('[data-zf-next]');
    var cur = 0;
    function mark(i) {
      cur = i;
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= slides.length - 1;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function go(i) {
      if (i < 0 || i >= slides.length) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    return { go: go };
  }

  function initBuy(root) {
    if (root.dataset.zfReady) return;
    root.dataset.zfReady = '1';
    var jsonEl = root.querySelector('[data-zf-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var gallery = initGallery(root);
    var form = root.querySelector('form[action*="/cart/add"]');
    var idInput = form.querySelector('[name="id"]');
    var prop = form.querySelector('[data-zf-prop]');
    var addBtn = form.querySelector('[data-zf-add]');
    var addText = form.querySelector('[data-zf-add-text]');
    var err = form.querySelector('[data-zf-error]');
    var packs = $$(root, '[data-zf-pack]');
    var rows = $$(root, '[data-zf-color-row]');
    var ship = root.querySelector('[data-zf-ship]');
    var sticky = root.querySelector('[data-zf-sticky]');
    var priceBox = root.querySelector('[data-zf-pricebox]');

    function checked(scope, sel) { var c = scope.querySelector(sel + ':checked'); return c ? c.value : null; }
    function findVariant(pack, color) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i];
        if (v.o[data.packIndex] !== pack) continue;
        if (data.colorIndex >= 0 && v.o[data.colorIndex] !== color) continue;
        return v;
      }
      return null;
    }
    function showColorMedia(color) {
      if (!gallery || !color) return;
      var stem = color.toLowerCase().slice(0, 4);
      for (var i = 0; i < data.media.length; i++) {
        if ((data.media[i].alt || '').indexOf(stem) !== -1) { gallery.go(i); return; }
      }
    }

    function update(changedColorRow) {
      var packInput = root.querySelector('[data-zf-pack]:checked') || packs[0];
      var pack = packInput.value;
      var n = parseInt(packInput.dataset.n, 10) || 1;
      var colors = [];
      rows.forEach(function (row, i) {
        row.hidden = i >= n;
        var label = row.querySelector('[data-zf-row-label]');
        if (label) label.textContent = n === 1 ? 'Kolor' : 'Sztuka ' + (i + 1);
        var val = checked(row, '[data-zf-color]');
        var out = row.querySelector('[data-zf-color-name]');
        if (out) out.textContent = val || '';
        if (i < n) colors.push(val);
      });
      var v = findVariant(pack, colors[0]);
      if (!v) { addBtn.disabled = true; addText.textContent = 'Niedostępne'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.a;
      addText.textContent = v.a ? data.addLabel + ' · ' + money(v.p) : 'Wyprzedane';

      prop.disabled = n < 2;
      prop.value = n > 1 ? colors.join(', ') : '';

      if (ship) {
        var free = data.freeFrom > 0 && v.p >= data.freeFrom;
        ship.classList.toggle('is-free', free);
        ship.querySelector('[data-zf-ship-text]').textContent = free ? ship.dataset.free : ship.dataset.paid;
      }
      if (priceBox) {
        var save = v.c > v.p ? v.c - v.p : 0;
        priceBox.querySelector('[data-zf-price]').textContent = money(v.p);
        var cmp = priceBox.querySelector('[data-zf-compare]');
        var off = priceBox.querySelector('[data-zf-off]');
        var saveEl = priceBox.querySelector('[data-zf-save]');
        cmp.hidden = off.hidden = saveEl.hidden = !save;
        if (save) {
          cmp.textContent = money(v.c);
          off.textContent = '−' + Math.round(save * 100 / v.c) + '%';
          saveEl.textContent = 'Oszczędzasz ' + money(save);
        }
      }
      if (sticky) {
        sticky.querySelector('[data-zf-sticky-price]').textContent = money(v.p);
        sticky.querySelector('[data-zf-sticky-pack]').textContent = pack;
      }
      if (changedColorRow === 0) showColorMedia(colors[0]);
    }

    packs.forEach(function (p) { p.addEventListener('change', function () { update(-1); }); });
    rows.forEach(function (row, i) {
      $$(row, '[data-zf-color]').forEach(function (inp) { inp.addEventListener('change', function () { update(i); }); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      err.hidden = true;
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(base + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (x.ok) { window.location.href = base + 'cart'; return; }
          err.textContent = x.j.description || x.j.message || 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.';
          err.hidden = false;
          addBtn.classList.remove('is-loading');
        })
        .catch(function () { form.submit(); });
    });

    if (sticky) {
      var sb = sticky.querySelector('[data-zf-sticky-add]');
      sb.addEventListener('click', function () { addBtn.click(); });
      if ('IntersectionObserver' in window) {
        var footerSeen = false, btnSeen = true;
        var set = function () {
          var on = !btnSeen && !footerSeen;
          sticky.classList.toggle('is-on', on);
          sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
          sb.tabIndex = on ? 0 : -1;
        };
        new IntersectionObserver(function (es) { btnSeen = es[0].isIntersecting || es[0].boundingClientRect.top > 0; set(); }).observe(addBtn);
        var feet = $$(document, 'footer, .zf-final'), seen = [];
        if (feet.length) {
          var fio = new IntersectionObserver(function (es) {
            es.forEach(function (e) { seen[feet.indexOf(e.target)] = e.isIntersecting; });
            footerSeen = seen.some(Boolean); set();
          });
          feet.forEach(function (f) { fio.observe(f); });
        }
      }
    }

    update(-1);
  }

  function initLog(list) {
    if (list.dataset.zfReady) return;
    list.dataset.zfReady = '1';
    var items = $$(list, 'li');
    if (reduce || !('IntersectionObserver' in window)) { items.forEach(function (li) { li.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -35% 0px' });
    items.forEach(function (li) { io.observe(li); });
  }

  /* Licznik do konkretnej daty końca promocji (data-zf-end, ISO). Po końcu chowa się i włącza tekst zastępczy. */
  function initCountdown(el) {
    if (el.dataset.zfReady) return;
    el.dataset.zfReady = '1';
    var daily = el.hasAttribute('data-zf-daily');
    var midnight = function () { var d = new Date(); d.setHours(24, 0, 0, 0); return d.getTime(); };
    var end = daily ? midnight() : Date.parse(el.dataset.zfEnd || '');
    var host = el.closest('[data-zf-promo]') || el;
    if (isNaN(end)) { host.classList.add('is-over'); return; }
    var dEl = el.querySelector('[data-d]'), hEl = el.querySelector('[data-h]'), mEl = el.querySelector('[data-m]'), sEl = el.querySelector('[data-s]');
    var dWrap = el.querySelector('[data-dwrap]'), dUnit = el.querySelector('[data-dunit]');
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    var timer;
    function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0 && daily) { end = midnight(); s = Math.floor((end - Date.now()) / 1000); }
      if (s <= 0) { host.classList.add('is-over'); clearInterval(timer); return; }
      var d = daily ? 0 : Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      if (dWrap) dWrap.hidden = d === 0;
      if (dEl) dEl.textContent = d;
      if (dUnit) dUnit.textContent = d === 1 ? 'dzień' : 'dni';
      hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* Przewidywana data dostawy: dziś + X..Y dni roboczych */
  function initEta(el) {
    if (el.dataset.zfReady) return;
    el.dataset.zfReady = '1';
    function add(n) {
      var d = new Date();
      while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
      return d;
    }
    var a = add(parseInt(el.dataset.min, 10) || 7), b = add(parseInt(el.dataset.max, 10) || 14);
    var fm = function (d, month) { return d.toLocaleDateString('pl-PL', month ? { day: 'numeric', month: 'long' } : { day: 'numeric' }); };
    el.textContent = a.getMonth() === b.getMonth() ? fm(a) + '–' + fm(b, true) : fm(a, true) + ' – ' + fm(b, true);
  }

  /* Zamarznięta szyba: kursor (albo palec) to ZipFrost, który zbiera szron */
  function initFrost(root) {
    if (root.dataset.zfReady) return;
    root.dataset.zfReady = '1';
    var stage = root.querySelector('[data-zf-stage]');
    var cv = root.querySelector('[data-zf-frost-canvas]');
    var ctx = cv.getContext('2d');
    var tool = root.querySelector('[data-zf-tool]');
    var hint = root.querySelector('[data-zf-hint]');
    var again = root.querySelector('[data-zf-again]');
    var sceneSvg = root.querySelector('[data-zf-scene]');
    var coarse = window.matchMedia && matchMedia('(pointer: coarse)').matches;
    if (hint && coarse && hint.dataset.touch) hint.textContent = hint.dataset.touch;
    var W = 0, H = 0, R = 30, last = null, dirty = false, done = false, touched = false, demoRun = false;
    var sceneImg = null, frostImg = null, active = false, spinT;
    var photo = root.querySelector('.zf-frost__photo'), frostEl = root.querySelector('[data-zf-frost-img]');
    // postęp liczony na siatce 48x30 (bez czytania pikseli, więc działa też ze zdjęciami z CDN)
    var GX = 48, GY = 30, grid = new Uint8Array(GX * GY), cleared = 0;
    function cover(img) { var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height, s = Math.max(W / iw, H / ih); return [(W - iw * s) / 2, (H - ih * s) / 2, iw * s, ih * s]; }

    function rand(a, b) { return a + Math.random() * (b - a); }
    function fern(x, y, a, len, d) {
      if (d <= 0 || len < 2) return;
      var x2 = x + Math.cos(a) * len, y2 = y + Math.sin(a) * len;
      ctx.lineWidth = Math.max(0.5, d * 0.55);
      ctx.beginPath(); ctx.moveTo(x, y); ctx.lineTo(x2, y2); ctx.stroke();
      for (var s = 1; s <= 3; s++) {
        var t = s / 4, bx = x + (x2 - x) * t, by = y + (y2 - y) * t, bl = len * 0.42 * (1 - t * 0.4);
        fern(bx, by, a - 1.05 + rand(-0.12, 0.12), bl, d - 1);
        fern(bx, by, a + 1.05 + rand(-0.12, 0.12), bl, d - 1);
      }
      fern(x2, y2, a + rand(-0.3, 0.3), len * 0.7, d - 1);
    }
    function paint() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
      grid.fill(0); cleared = 0;
      if (frostImg) {
        var fc = cover(frostImg);
        ctx.drawImage(frostImg, fc[0], fc[1], fc[2], fc[3]);
        done = false; stage.classList.remove('is-clear');
        return;
      }
      if (sceneImg) {
        // rozmyty widok przez szron: pomniejsz i powiększ = rozmycie działające też w Safari
        var sw = Math.max(8, Math.round(W / 22)), sh = Math.max(6, Math.round(H / 22));
        var off = document.createElement('canvas'); off.width = sw; off.height = sh;
        var sc = cover(sceneImg), k0 = sw / W;
        off.getContext('2d').drawImage(sceneImg, sc[0] * k0, sc[1] * k0, sc[2] * k0, sc[3] * k0);
        ctx.imageSmoothingEnabled = true;
        ctx.drawImage(off, 0, 0, W, H);
      } else {
        ctx.fillStyle = '#5E7590'; ctx.fillRect(0, 0, W, H);
      }
      ctx.fillStyle = 'rgba(222, 233, 243, 0.8)';
      ctx.fillRect(0, 0, W, H);
      var g = ctx.createRadialGradient(W / 2, H * 0.45, Math.min(W, H) * 0.2, W / 2, H * 0.5, Math.max(W, H) * 0.75);
      g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(246,250,253,0.75)');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      // ziarno szronu
      var n = document.createElement('canvas'); n.width = n.height = 96;
      var nc = n.getContext('2d'), id = nc.createImageData(96, 96);
      for (var i = 0; i < id.data.length; i += 4) {
        var v = Math.random();
        var white = v > 0.5;
        id.data[i] = id.data[i + 1] = white ? 255 : 150; id.data[i + 2] = white ? 255 : 175;
        id.data[i + 3] = white ? (v > 0.86 ? 200 : 40) : (v < 0.08 ? 60 : 0);
      }
      nc.putImageData(id, 0, 0);
      ctx.fillStyle = ctx.createPattern(n, 'repeat'); ctx.fillRect(0, 0, W, H);
      // kryształki lodu rosnące od krawędzi
      ctx.strokeStyle = 'rgba(255,255,255,0.6)'; ctx.lineCap = 'round';
      var count = Math.round((W + H) / 26), base = Math.min(W, H) * 0.12;
      for (var k = 0; k < count; k++) {
        var side = k % 4, x, y, a;
        if (side === 0) { x = rand(0, W); y = 0; a = Math.PI / 2; }
        else if (side === 1) { x = W; y = rand(0, H); a = Math.PI; }
        else if (side === 2) { x = rand(0, W); y = H; a = -Math.PI / 2; }
        else { x = 0; y = rand(0, H); a = 0; }
        fern(x, y, a + rand(-0.7, 0.7), base * rand(0.6, 1.4), 4);
      }
      for (var j = 0; j < count / 2; j++) {
        ctx.strokeStyle = 'rgba(255,255,255,' + rand(0.25, 0.5).toFixed(2) + ')';
        fern(rand(0, W), rand(0, H), rand(0, Math.PI * 2), base * rand(0.3, 0.7), 3);
      }
      done = false; stage.classList.remove('is-clear');
    }
    function size() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || (w === W && h === H)) return;
      W = w; H = h;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      R = Math.max(22, Math.min(W, H) * 0.072);
      root.style.setProperty('--zf-tool', Math.round(R * 2.1) + 'px');
      paint();
    }
    function loadScene() {
      if (photo) {
        var go = function () { sceneImg = photo; if (!touched) paint(); };
        if (photo.complete && photo.naturalWidth) go(); else photo.addEventListener('load', go);
        if (frostEl) {
          var fi = new Image();
          fi.onload = function () { frostImg = fi; if (!touched) paint(); };
          fi.src = frostEl.getAttribute('src');
        }
        return;
      }
      if (!sceneSvg || !window.XMLSerializer) return;
      var c = sceneSvg.cloneNode(true);
      c.setAttribute('width', W); c.setAttribute('height', H);
      var url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(new XMLSerializer().serializeToString(c));
      var img = new Image();
      img.onload = function () { sceneImg = img; if (!touched) paint(); };
      img.src = url;
    }
    function dab(x, y) {
      var g = ctx.createRadialGradient(x, y, R * 0.5, x, y, R);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, R, 0, Math.PI * 2); ctx.fill();
      var r = R * 0.8, x0 = Math.max(0, Math.floor((x - r) / W * GX)), x1 = Math.min(GX - 1, Math.floor((x + r) / W * GX));
      var y0 = Math.max(0, Math.floor((y - r) / H * GY)), y1 = Math.min(GY - 1, Math.floor((y + r) / H * GY));
      for (var gy = y0; gy <= y1; gy++) for (var gx = x0; gx <= x1; gx++) {
        var cx = (gx + 0.5) * W / GX - x, cy = (gy + 0.5) * H / GY - y;
        if (cx * cx + cy * cy <= r * r && !grid[gy * GX + gx]) { grid[gy * GX + gx] = 1; cleared++; }
      }
    }
    function scrape(x, y) {
      if (done) return;
      ctx.globalCompositeOperation = 'destination-out';
      if (!last) last = { x: x, y: y };
      var dx = x - last.x, dy = y - last.y, steps = Math.max(1, Math.ceil(Math.sqrt(dx * dx + dy * dy) / (R / 4)));
      for (var i = 1; i <= steps; i++) dab(last.x + dx * i / steps, last.y + dy * i / steps);
      last = { x: x, y: y };
      dirty = true;
    }
    function moveTool(x, y) {
      tool.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      tool.classList.add('is-spin');
      clearTimeout(spinT);
      spinT = setTimeout(function () { tool.classList.remove('is-spin'); }, 180);
    }
    function check() {
      if (dirty && !done) {
        dirty = false;
        if (cleared / (GX * GY) > 0.6) finish();
      }
      setTimeout(check, 300);
    }
    function finish() {
      done = true;
      stage.classList.add('is-clear');
      tool.classList.remove('is-on');
    }
    function firstTouch() {
      if (touched) return;
      touched = true;
      stage.classList.add('is-touched');
    }
    function pos(e) { var r = stage.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }

    stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && !done) tool.classList.add('is-on'); last = null; });
    stage.addEventListener('pointerleave', function () { tool.classList.remove('is-on'); last = null; active = false; });
    stage.addEventListener('pointerdown', function (e) {
      if (done) return;
      active = true; last = null;
      if (e.pointerType !== 'mouse') { try { stage.setPointerCapture(e.pointerId); } catch (x) {} }
      var p = pos(e); firstTouch(); tool.classList.add('is-on'); moveTool(p.x, p.y); scrape(p.x, p.y);
    });
    stage.addEventListener('pointermove', function (e) {
      if (demoRun) return;
      var p = pos(e);
      if (e.pointerType === 'mouse') {
        if (!done) { tool.classList.add('is-on'); moveTool(p.x, p.y); firstTouch(); scrape(p.x, p.y); }
      } else if (active) {
        e.preventDefault(); moveTool(p.x, p.y); scrape(p.x, p.y);
      }
    });
    ['pointerup', 'pointercancel'].forEach(function (t) {
      stage.addEventListener(t, function (e) { active = false; last = null; if (e.pointerType !== 'mouse') tool.classList.remove('is-on'); });
    });
    // klawiatura: Enter / spacja czyści szybę
    stage.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && !done) { e.preventDefault(); firstTouch(); sweep(true); }
    });
    if (again) again.addEventListener('click', function () { last = null; paint(); stage.focus({ preventScroll: true }); });

    // pokaz: ZipFrost sam przejeżdża pasem po szybie, potem kolej użytkownika
    function sweep(full) {
      demoRun = true;
      var t0 = null, dur = full ? 2600 : 1500;
      tool.classList.add('is-on'); last = null;
      function frame(ts) {
        if (t0 === null) t0 = ts;
        var t = Math.min(1, (ts - t0) / dur);
        var x, y;
        if (full) { var rows = 5, row = Math.min(rows - 1, Math.floor(t * rows)), f = t * rows - row; x = W * (0.06 + 0.88 * (row % 2 ? 1 - f : f)); y = H * (0.12 + row * 0.19); }
        else { x = W * (0.14 + 0.72 * t); y = H * (0.56 - 0.16 * Math.sin(t * Math.PI)); }
        moveTool(x, y); scrape(x, y);
        if (t < 1) requestAnimationFrame(frame);
        else { demoRun = false; last = null; if (!full) tool.classList.remove('is-on'); else finish(); stage.classList.add('is-demoed'); }
      }
      requestAnimationFrame(frame);
    }

    size(); loadScene(); check();
    if (window.ResizeObserver) new ResizeObserver(function () { var w = W; size(); if (w && w !== W) { loadScene(); } }).observe(stage);
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) {
          io.disconnect();
          setTimeout(function () { if (!touched && !done) sweep(false); }, 700);
        }
      }, { threshold: 0.6 });
      io.observe(stage);
    }
  }

  function initHeader() {
    var hdr = document.querySelector('.zf-hdr');
    var group = hdr && hdr.closest('#header-group');
    if (!group || group.dataset.zfReady) return;
    group.dataset.zfReady = '1';
    group.classList.add('zf-hgroup');
    var bar = group.querySelector('.zf-bar');
    var fit = function () { group.style.top = bar ? -bar.offsetHeight + 'px' : '0px'; };
    fit();
    if (window.ResizeObserver && bar) new ResizeObserver(fit).observe(bar);
  }

  function init(scope) {
    initHeader();
    var s = scope || document;
    $$(s, '[data-zf-buy]').forEach(initBuy);
    $$(s, '[data-zf-log]').forEach(initLog);
    $$(s, '[data-zf-cd]').forEach(initCountdown);
    $$(s, '[data-zf-eta]').forEach(initEta);
    $$(s, '[data-zf-frost]').forEach(initFrost);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
